/* Ardor Rigid Sign Designer: price function (v2). Data: assets/ardor-rigid-price-data.js. Generated; do not edit. */
(function (root) {
  'use strict';
  function cents(x) { return Math.round(x * 100 + 1e-7) / 100; }
  function floorCents(x) { return Math.floor(x * 100) / 100; }
  function up(v, grid) { for (var i = 0; i < grid.length; i++) if (grid[i] >= v - 1e-9) return grid[i]; return null; }
  function onGrid(v, grid) { for (var i = 0; i < grid.length; i++) if (Math.abs(grid[i] - v) < 1e-9) return true; return false; }
  function unitBoard(m, w, h, o) {
    var sides = m.sidesAllowed.indexOf(o.sides) >= 0 ? o.sides : '1';
    var key = m.rateBy === 'material' ? (o.material || m.defaults.material) + '|' + sides : sides;
    var rate = m.rate[key];
    if (rate === undefined) throw new Error('no rate for ' + key);
    var base = cents(w * h * rate / 144);
    var add = 0, sc = m.surcharges || {};
    for (var g in sc) { var v = o[g] !== undefined ? o[g] : m.defaults[g]; if (v !== undefined && sc[g][v]) add += sc[g][v]; }
    var mn = m.minimum[sides] !== undefined ? m.minimum[sides] : m.minimum['1'];
    return Math.max(cents(base + add), mn);
  }
  function corUnit(data, m, w, h, o, qty, pickupBeyondSupplier) {
    var sides = o.sides === '2' ? '2' : '1';
    var add = 0, sc = m.surcharges;
    var gk = o.grommet !== undefined ? o.grommet : '0', hk = o.hardware !== undefined ? o.hardware : 'so';
    if (sc.grommet[gk]) add += sc.grommet[gk];
    if (sc.hardware[hk]) add += sc.hardware[hk];
    var rate = m.rate[sides];
    if (pickupBeyondSupplier) {
      return cents(w * h / 144 * m.oversizeSheetRate[sides]) + add;
    }
    var u1 = Math.max(m.minimum[sides], Math.min(floorCents(w * h * rate / 144), m.sheetPrice[sides]));
    if (qty <= 1) return cents(u1 + add);
    var F = data.corFine;
    if (F) {
      var Wi = Math.max(F.min, Math.ceil(w - 1e-9)), Hi = Math.max(F.min, Math.ceil(h - 1e-9)), ref = F.idx[Wi + 'x' + Hi];
      if (ref) {
        var tb = F.tables[ref[sides === '2' ? 1 : 0]].split(','), uf = u1;
        for (var f2 = 0; f2 < tb.length && tb[f2]; f2++) { var e2 = tb[f2].split(':'); if (qty >= +e2[0]) uf = +e2[1] / 100; else break; }
        if (Wi !== w || Hi !== h) uf = Math.ceil(uf * F.offGridMargin * 100 - 1e-6) / 100;
        return cents(Math.min(uf, u1) + add);
      }
    }
    var W = up(w, data.corGrid.w), H = up(h, data.corGrid.h);
    var key = W + 'x' + H, pb = (data.corPB[key] || {})[sides];
    if (!pb) throw new Error('no coroplast price-break table for cell ' + key);
    var u = pb[0][1];
    for (var i = 0; i < pb.length; i++) { if (qty >= pb[i][0]) u = pb[i][1]; }
    if (W !== w || H !== h) u = Math.ceil(u * (m.offGridTableMargin || 1) * 100 - 1e-6) / 100;
    return cents(Math.min(u, u1) + add);
  }
  function shipBoard(data, group, L, S, q) {
    var g = data.ship[group]; if (!g) throw new Error('no ship group ' + group);
    if (onGrid(L, g.gridL) && onGrid(S, g.gridS)) return shipCell(data, g, group, L, S, q);
    if (g.envelope) {
      var e = g.envelope, base = shipCell(data, g, group, L, S, q), best = base.shipping, exact = false;
      var dL = e.step, offs = e.offsets || [[1, 0], [0, 1], [1, 1]], nb = [];
      var rolled = L > e.smallL || S > e.smallS;
      if (rolled) for (var o2 = 0; o2 < offs.length; o2++) nb.push([L - dL * offs[o2][0], S - dL * offs[o2][1]]);
      var margin = rolled ? e.marginLarge : e.marginSmall;
      for (var n = 0; n < nb.length; n++) {
        if (nb[n][0] < g.gridL[0] || nb[n][1] < g.gridS[0] || nb[n][1] > nb[n][0]) continue;
        try { var v = shipCell(data, g, group, nb[n][0], nb[n][1], q).shipping; if (v > best) best = v; } catch (e) {  }
      }
      return { shipping: Math.ceil(best * margin * 100 - 1e-6) / 100, cell: base.cell, exact: exact };
    }
    var r = shipCell(data, g, group, L, S, q);
    if (g.margin && g.margin !== 1) r = { shipping: Math.ceil(r.shipping * g.margin * 100 - 1e-6) / 100, cell: r.cell, exact: false };
    return r;
  }
  function shipCell(data, g, group, L, S, q) {
    var cl = up(L, g.gridL), cs = up(S, g.gridS);
    if (cl === null || cs === null) throw new Error('size outside ship grid');
    if (cs > cl) { var t = cs; cs = up(cl, g.gridS); cl = up(t, g.gridL); }
    var cellKey = cl + 'x' + cs, c = g.cells[cellKey];
    if (!c) throw new Error('no ship cell ' + group + ' ' + cellKey);
    var k = c[0], j = c[1], C = data.C[c[2]], dev = c[3], exact = true;
    function P(r) {
      if (r <= j) return C[r - 1];
      for (var i = 0; i < dev.length; i++) if (dev[i][0] >= r) { if (dev[i][0] !== r) exact = false; return dev[i][1]; }
      throw new Error('qty beyond ship data for ' + group + ' ' + cellKey + ' r=' + r);
    }
    var s;
    if (!k) { if (q > data.maxQty) throw new Error('qty above data range'); s = P(q); }
    else { var m = Math.floor(q / k), r = q % k; s = m * P(k) + (r ? P(r) : 0); }
    return { shipping: cents(s), cell: cellKey, exact: exact };
  }
  function shipCor(data, w, h, o, q) {
    var W = up(w, data.corGrid.w), H = up(h, data.corGrid.h), key = W + 'x' + H;
    var c = data.corShip[key]; if (!c) throw new Error('no coroplast ship cell ' + key);
    var g = o.grommet && o.grommet !== '0', hs = o.hardware === '1';
    var signV = g ? (o.grommet === 'CT' && c.k.gt ? 'gt' : 'g') : 'p';
    var k = c.k[signV]; if (!k) throw new Error('no coroplast box size for ' + key + ' ' + signV);
    var s = Math.ceil(q / k) * c.b, exact = true;
    if (hs) {
      var hv = g ? (o.grommet === 'CT' ? 'hCT' : 'hC') : 'h', cs = data.corStakeCells && data.corStakeCells[key] && data.corStakeCells[key][hv];
      var st = data.corStake[g ? 'withGrommets' : 'plain'];
      var ex = Math.max(0, Math.ceil((q - st.free) / st.perBox)) + st.spare;
      if (cs) {
        ex = q < cs[0] ? 0 : Math.min(ex, Math.ceil(q / data.corStake.perStakeBox) + cs[1]);
      }
      s += ex * data.corStake.boxPrice; exact = !!cs && exact && q < cs[0];
    }
    return { shipping: cents(s), cell: key, exact: exact };
  }
  function rsPrice(data, mat, w, h, opts, qty) {
    var m = data.materials[mat]; if (!m) throw new Error('unknown material ' + mat);
    var o = {}; for (var d in m.defaults) o[d] = m.defaults[d]; for (var x in (opts || {})) o[x] = opts[x];
    qty = Math.max(1, Math.floor(qty || 1));
    if (w < m.min.w || h < m.min.h) throw new Error('below minimum size ' + m.min.w + 'x' + m.min.h);
    var L = Math.max(w, h), S = Math.min(w, h);
    var shippable = L <= m.shipMax.long + 1e-9 && S <= m.shipMax.short + 1e-9;
    var inPickup = false, beyondSupplier = false;
    if (!shippable) {
      for (var i = 0; i < m.pickupMax.length; i++) { var p = m.pickupMax[i]; if (L <= p.long + 1e-9 && S <= p.short + 1e-9) { inPickup = true; if (p.beyondSupplier) beyondSupplier = true; break; } }
      if (inPickup && beyondSupplier) {
        for (var i2 = 0; i2 < m.pickupMax.length; i2++) { var p2 = m.pickupMax[i2]; if (!p2.beyondSupplier && L <= p2.long + 1e-9 && S <= p2.short + 1e-9) { beyondSupplier = false; break; } }
      }
      if (!inPickup) throw new Error('size above the maximum for ' + mat);
    }
    var unit = mat === 'COR' ? corUnit(data, m, w, h, o, qty, beyondSupplier) : unitBoard(m, w, h, o);
    var sub = cents(unit * qty);
    if (!shippable) return { supplierUnit: unit, supplierSubtotal: sub, shipping: 0, ours: cents(2 * sub), pickupOnly: true, cell: null, exactShipping: null };
    var sh;
    if (mat === 'COR') sh = shipCor(data, w, h, o, qty);
    else {
      var grp = m.shipGroup;
      if (m.shipGroupBy) for (var gk in m.shipGroupBy) { var val = o[gk]; if (val !== undefined && m.shipGroupBy[gk][val]) grp = m.shipGroupBy[gk][val]; }
      sh = shipBoard(data, grp, L, S, qty);
    }
    var f = (mat === 'COR' ? data.shipFactorCOR : data.shipFactor) || 1, ship = sh.shipping;
    if (f !== 1) ship = Math.ceil(ship * f * 100 - 1e-6) / 100;
    return { supplierUnit: unit, supplierSubtotal: sub, shipping: ship, ours: cents(2 * (sub + ship)), pickupOnly: false, cell: sh.cell, exactShipping: sh.exact && f === 1 };
  }
  root.ArdorRigidPrice = { v: 'rsprice-6ebac512', rsPrice: rsPrice, cents: cents };
  if (typeof module !== 'undefined' && module.exports) module.exports = { rsPrice: rsPrice, cents: cents };
})(typeof window !== 'undefined' ? window : globalThis);
